// service/socketo.js

import { io } from "socket.io-client";

// Replace 'http://localhost:3000' with your actual socket server URL
const socketo = io("https://api.exar.fit/socket.io/");

export { socketo };
